import { CustomAction } from '..';

export interface Checkout_Obj {
    id: string;
    form_valid: boolean;
    title_text: string;
    sub_title_text: string;
    comment_text: string;
}

export interface Checkout_Stage_Obj {
    [props: string]: Checkout_Obj;
}

export const checkout_default_value: Checkout_Stage_Obj = {
    '1': {
        id: '1',
        form_valid: false,
        title_text: 'Sign Up',
        sub_title_text: 'Let us know a little bit more about you so that we can move forward.',
        comment_text: 'This information will be used to create login credentials for you.'
    },
    '2': {
        id: '2',
        form_valid: false,
        title_text: 'Almost done',
        sub_title_text: 'We won\'t charge anything until you decide to increase your usage limits.',
        comment_text: 'Your card won\'t be charged without your consent.'
    },
    '3': {
        id: '3',
        form_valid: false,
        title_text: 'Sign Up Successful',
        sub_title_text: 'An email was sent with temporary credentials. Use these when you are prompted to log in',
        comment_text: 'Please check your inbox or spam folder.'
    },
    '4': {
        id: '4',
        form_valid: false,
        title_text: 'Almost done',
        sub_title_text: 'We won\'t charge anything until you decide to increase your usage limits.',
        comment_text: 'Your card won\'t be charged without your consent.'
    },
    '5': {
        id: '5',
        form_valid: false,
        title_text: 'Almost done',
        sub_title_text: 'We won\'t charge anything until you decide to increase your usage limits.',
        comment_text: 'Your card won\'t be charged without your consent.'
    }
};

export interface Signup_Details_Actions {
    undefined: Function;
    CHECKOUT_UPDATE: Function;
}

export const actions: Signup_Details_Actions = {
    'undefined': (state = null, payload: any) => state,
    CHECKOUT_UPDATE: (state: Checkout_Stage_Obj, payload: Checkout_Stage_Obj) => payload
};

export function checkoutReducer (state: Checkout_Stage_Obj, action: CustomAction): Checkout_Stage_Obj {
    if (['CHECKOUT_UPDATE'].includes(action.type) && Object.keys(actions).includes(action.type)) return actions[action.type](state, action.payload);

    return state != undefined ? state : checkout_default_value;
}


// WEBPACK FOOTER //
// ./src/store/reducers/checkout_stage.reducers.ts